module.exports = __webpack_public_path__ + "img/chr_ts_4.1a407767.png";